import React, { useMemo, useCallback, useContext, useEffect, useState } from "react";
import DatePicker from "@acadia-ui/datepicker";
import { ToolbarContext } from "@acadia-ui/toolbar";
import { shouldFilter, inferDateRangeFromFilterPresets } from "../utils";

export default function useDatePicker({ isOpen, prefix }) {
	const context = useContext(ToolbarContext);
	const [value, setValue] = useState([]);

	useEffect(() => {
		if (isOpen) {
			if (shouldFilter(`${prefix}-filter-date`, context?.filterValues)) {
				const [startFilter, endFilter] = inferDateRangeFromFilterPresets(context?.filterValues?.[`${prefix}-filter-date`]);
				setValue([startFilter, endFilter]);
			}
		} else {
			setValue([]);
		}
		// Intentionally exclude context from deps array as we only want to rerender when isOpen changes to true
	}, [isOpen, prefix]);

	const handleOnChange = useCallback(([startDate, endDate]) => {
		setValue([startDate, endDate]);
	}, []);

	return useMemo(() => {
		return {
			element: (
				<DatePicker
					// This comment exists to prevent eslint from making this unreadable.
					className={"gos-pm-filters-sidesheet-datepicker"}
					range={true}
					endLabel={"End"}
					value={value}
					onChange={handleOnChange}
					openOnClick={true}
				>
					Start
				</DatePicker>
			),
			value,
			setValue
		};
	}, [handleOnChange, value]);
}
